import { useDispatch } from 'react-redux'
import Actions from '../../../Flux/index.js'
import { useGetAuthenticatedUser } from '../../../Flux/Selector/index.js'
import { canUseSpin } from '../../../Model/index.js'
import { projectSlice } from '../../../Flux/Slice/Project/ProjectSlice.js'
import type { IEvaluationProject } from '../../../Model/Project/IEvaluationProject.js'
import type { BaseModalProps } from '../../Modal/BaseModal.js'
import { ReportSettingsModal } from '../../Component/Report/ReportSettingsModal.tsx'
import type { TargetTaxonomyKey } from '../../../Generated/TargetTaxonomy.ts'

export interface ProjectReportModalProps {
  project: IEvaluationProject
}

/** Project side of {@link ReportSettingsModal}. */
export const ProjectReportModal = ({ isOpen, onClose, project }: ProjectReportModalProps & BaseModalProps) => {
  const dispatch = useDispatch()
  const user = useGetAuthenticatedUser()

  return (
    <ReportSettingsModal
      isOpen={isOpen}
      onClose={onClose}
      testId="project-report-modal"
      title="Generate Project Report"
      scope="project"
      scopeDefaultLabel="Project Default"
      redlistDefaultLabel="Project / Organization Default"
      defaultTaxonomy={(project.targetTaxonomy as TargetTaxonomyKey) || null}
      defaultRedlist={project.redlistMode || null}
      spinAccess={canUseSpin(user)}
      onConfirm={(settings) =>
        dispatch(
          Actions[projectSlice.name].getReportRequest({
            projectId: project.id,
            projectName: project.name,
            settings
          })
        )
      }
    />
  )
}
